<template>
  <div>
     <NzmRightscroll v-if="info.config.show_type === 'm01'" :info="info" :data_list="data_list" />
     <NzmListAward v-else-if="info.config.show_type === 'm02'" :info="info" :data_list="data_list"/>
     <FzsAward v-else-if="info.config.show_type === 'm03'" :info="info" :data_list="data_list"/>
  </div>
</template>
<script>
import { getJSON } from '../../api/myaxios';
import { onUseInfoLoad } from '../../tools/onUseInfoLoad';
import NzmRightscroll from './NzmBenefit/NzmRightscroll.vue'
import NzmListAward from './NzmBenefit/NzmListAward.vue'
import FzsAward from './NzmBenefit/FzsAward.vue'
import {menuArr} from '../../constant/class'
const JINGXUAN_TYPE = '0';

export default {
  name: 'NzmBenefitRecv',
  components: {
    NzmRightscroll,
    NzmListAward,
    FzsAward
  },
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data: function() {
    return {
      data_list: []
    };
  },
  created() {
    onUseInfoLoad(() => {
      this.get_detail();
    }, false);
  },
  methods: {
    get_detail: function(type = JINGXUAN_TYPE) {
      const params = {
        act_name: this.info.act_name,
        invoker: window.gact.invoker,
        ticket: window.$bus.user.ticket,
        f_release: window.gact.f_release
      };
      params.is_all = type;

      getJSON(
        '//vipact3.api.mgtv.com/api/v1/act/vipbenefits/m/list',
        params,
        10000,
        false,
        true
      ).then(res => {
        if (!res) {
          return;
        }
        if (res.ret === 0) {
          this.data_list = res.data.list.slice(0, this.info.config.max_num)
          if(this.info.config.show_type === 'm03'){
            // 处理蜂助手，根据是否贵重的字段来分类，会员用户的数据是贵重  非会员是不贵重
            this.data_list = res.data.list.slice(0, this.info.config.max_num * menuArr.length * 2)
            this.data_list = this.data_list.filter(item => {
              if(item.award_type === 61){
                if(window.$bus.user.vip_id){
                  return item.award_flag === 1
                }else{
                  return item.award_flag === 0
                }
              }else{
                return true
              }
            })
          }
        }
      });
    }
  },
  mounted() {},
  computed: {
    user() {
      return window.$bus.user;
    },
  }
};
</script>

<style lang="stylus" scoped>
@import "../../share/mixins.styl"

</style>
